import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b4ed9df8&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./style/dialog.scss?vue&type=style&index=0&id=b4ed9df8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ed9df8",
  null
  
)

export default component.exports